import cx from 'classnames';
import {useMemo} from 'react';
import {IconUnit} from '~/common/fabric/Card/components/IconUnit/IconUnit';
import './Icons.sass';

const getIconId = (icon) => (typeof icon === 'object' ? icon?.id : icon || 'none');
export const Icons = ({
  icons = [],
  onClick,
  square = false,
  selectedIcon,
  height = 32,
  width = 32,
  className,
  mobile,
  hideAnimatedIndicator = false,
  outline = false,
  flipEnvelope,
  showEnvelopeFront,
}) => {
  const iconsMemo = useMemo(
    () =>
      icons?.map((icon, idx) => {
        const iconId = getIconId(icon);
        return (
          <IconUnit
            key={iconId}
            icon={icon}
            onClick={onClick}
            square={square}
            isActive={getIconId(selectedIcon) === iconId}
            height={height}
            width={width}
            mobile={mobile}
            hideAnimatedIndicator={hideAnimatedIndicator}
            outline={outline}
            loading={idx < 8 ? 'eager' : 'lazy'}
            flipEnvelope={flipEnvelope}
            showEnvelopeFront={showEnvelopeFront}
          />
        );
      }),
    [
      selectedIcon,
      square,
      height,
      width,
      icons,
      flipEnvelope,
      hideAnimatedIndicator,
      mobile,
      onClick,
      outline,
      showEnvelopeFront,
    ]
  );
  return (
    <div
      className={cx('icons', className, {
        'icons--mobile': mobile,
      })}
    >
      {iconsMemo}
    </div>
  );
};
